module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Color-0ab65b083fbc54da41e207f7b60d8a42312d1bb8e91c319f6de474820ac0b469.svg";